import React from 'react'
import { SourceLinkerSkeleton } from '@fs/zion-linker'
import useSourceLinkerParams from './useSourceLinkerParams'

/**
 * The source linker skeleton, wired to the query string. The skeleton's return buttons are real
 * links when it knows the record and tree person, and those come from the url rather than from
 * anything we have to fetch first.
 * @returns the loading skeleton for the source linker page
 */
export default function SourceLinkerSkeletonFallback(): JSX.Element {
  const { recordId, treePersonId } = useSourceLinkerParams()

  return <SourceLinkerSkeleton recordId={recordId} treePersonId={treePersonId} />
}
